module.exports = __webpack_public_path__ + "img/products11.a429062c.jpg";